import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import fi from 'date-fns/locale/fi';
import enGB from 'date-fns/locale/en-GB';
import { Calendar } from '../../../images';

const ChablaDatePicker = ({ onChange, isValid, ...rest }) => {
  useEffect(() => {
    registerLocale('fi', fi);
    registerLocale('en-GB', enGB);
  }, []);
  const { i18n } = useTranslation();
  const props = {
    ...rest,
    onChange,
    isValid,
  };
  const locale = (i18n.language || 'fi').substr(0, 2);
  return (
    <InputGroup className="customDateTimePicker">
      <DatePicker
        {...props}
        locale={locale === 'en' ? 'en-GB' : locale} // Monday is first day of week
        customInput={
          <Input isInvalid={!isValid} errorBorderColor="brand.50" bg="brand.10" borderRadius={0} />
        }
      />
      <InputRightElement>
        <Calendar style={{ maxWidth: 'unset' }} />
      </InputRightElement>
    </InputGroup>
  );
};

ChablaDatePicker.propTypes = {
  isValid: PropTypes.bool,
  onChange: PropTypes.func,
};

ChablaDatePicker.defaultProps = {
  isValid: true,
  onChange: () => {},
};

export default ChablaDatePicker;
